import React from 'react';

import { AnimatedText } from '@/components/animated-text';
import { Static } from '@/components/static-section';


export const NeedHelp = (props: Props) => {
  return (
    <Static backgroundColor="bg-partners" textColor="text-dark" id="partners">
      <div className="w-full bg-partners">
        <div className="flex h-full flex-col items-center justify-end px-4 py-[83px] text-center tablet:py-[120px] desktop:py-[160px] desktopXL:py-[200px]">
          <h2 className="font-heldane text-homeLetsTalk font-normal leading-[1.2] tracking-[-1%] text-navy desktop4k:leading-snug">
            Need help turning your big ideas into reality? <br />
            <a href="mailto:hello@all-turtles.com">
              <span className="text-at underline desktop4k:pt-4">
                <AnimatedText>Let&#39;s talk.</AnimatedText>
              </span>
            </a>
          </h2>
        </div>
      </div>
    </Static>
  );
};
